/**
 * Contains the paths used for routing
 */

export const PATHS = {
  root: "/",
  releaseNotes: "/release-notes",
  ssmlGuide: "/ssml-guide",
  ssmlCheatSheet: "/ssml-cheat-sheet",
  copyright: "/copyright",
  thirdPartyNotices: "/third-party-notices",
};
